//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      readonlyItems: [
        { key: 'organization', name: 'Наименование эксплуатирующей объект организации' },
        { key: 'additionals', name: 'Приложения к наряду-допуску' },
        { key: 'worksDescr', name: 'Описание работ' },
        { key: 'precautions', name: 'Меры по обеспечению безопасности' },
        { key: 'permission', name: 'Письменное разрешения на проведения работ со стороны эксплуатирующей объект организации' }
      ]
    }
  },
  methods: {
    formatPrecautions: function (array) {
      return array ? array.join('\n\n') : null
    },
    formatWorksDescr: function (array) {
      return array ? array.join(', ') : null
    },
    formatAdditionals: function (additionals) {
      if (additionals) {
        return additionals.join(', ')
      }
    },
    getItemValue: function (key, item) {
      let value = null
      switch (key) {
        case 'additionals':
          value = this.formatAdditionals(item)
          break
        case 'worksDescr':
          value = this.formatWorksDescr(item)
          break
        case 'precautions':
          value = this.formatPrecautions(item)
          break
        default:
          value = item
          break
      }
      return value || 'Нет данных'
    }
  }
}

